import rank1 from '../../../../assets/games/rankNumbers/rank_1.svg?raw';
import rank10 from '../../../../assets/games/rankNumbers/rank_10.svg?raw';
import rank11 from '../../../../assets/games/rankNumbers/rank_11.svg?raw';
import rank12 from '../../../../assets/games/rankNumbers/rank_12.svg?raw';
import rank13 from '../../../../assets/games/rankNumbers/rank_13.svg?raw';
import rank14 from '../../../../assets/games/rankNumbers/rank_14.svg?raw';
import rank15 from '../../../../assets/games/rankNumbers/rank_15.svg?raw';
import rank16 from '../../../../assets/games/rankNumbers/rank_16.svg?raw';
import rank17 from '../../../../assets/games/rankNumbers/rank_17.svg?raw';
import rank18 from '../../../../assets/games/rankNumbers/rank_18.svg?raw';
import rank19 from '../../../../assets/games/rankNumbers/rank_19.svg?raw';
import rank2 from '../../../../assets/games/rankNumbers/rank_2.svg?raw';
import rank20 from '../../../../assets/games/rankNumbers/rank_20.svg?raw';
import rank3 from '../../../../assets/games/rankNumbers/rank_3.svg?raw';
import rank4 from '../../../../assets/games/rankNumbers/rank_4.svg?raw';
import rank5 from '../../../../assets/games/rankNumbers/rank_5.svg?raw';
import rank6 from '../../../../assets/games/rankNumbers/rank_6.svg?raw';
import rank7 from '../../../../assets/games/rankNumbers/rank_7.svg?raw';
import rank8 from '../../../../assets/games/rankNumbers/rank_8.svg?raw';
import rank9 from '../../../../assets/games/rankNumbers/rank_9.svg?raw';

export const RANK_SVGS: Record<number, string> = {
  1: rank1,
  2: rank2,
  3: rank3,
  4: rank4,
  5: rank5,
  6: rank6,
  7: rank7,
  8: rank8,
  9: rank9,
  10: rank10,
  11: rank11,
  12: rank12,
  13: rank13,
  14: rank14,
  15: rank15,
  16: rank16,
  17: rank17,
  18: rank18,
  19: rank19,
  20: rank20,
};
